<div class="mobile-menu-wrapper">
	<ea-button-link (onClick)="handleToggle()" name="SupportDropdown">
		Support
		<ea-toggle-link
			textWhenToggled=""
			textWhenUntoggled=""
			[isToggled]="isSupportServicesToggled"
			name="toggleProfileActions"
		>
		</ea-toggle-link>
	</ea-button-link>
	<ea-collapsible-panel [visible]="isSupportServicesToggled">
		<ul>
			<li>
				<ea-button-link
					(onClick)="navigate(constants.routes.support)"
					name="supportLink"
					buttonRole="link"
					class="navigation-menu-items"
					>Support
				</ea-button-link>
			</li>
			@if (allowEdAccessSupportLink) {
				<li>
					<ea-button-link
						(onClick)="navigate(constants.routes.educationAccess.learnMore)"
						name="AboutNoCostBachelorsDegreeProgramLink"
						buttonRole="link"
						class="navigation-menu-items"
						>About No Cost Bachelor's Degree Program
					</ea-button-link>
				</li>
			}
			@if (liveChatEnabled) {
				<li>
					<ea-live-chat-button
					class="navigation-menu-items"
					buttonText="Get Live Help"
				></ea-live-chat-button>
				</li>
			}
		</ul>
	</ea-collapsible-panel>
</div>
